import { Compass, PenLine, Search, MessageCircle, Mail, Target } from "lucide-react";

const ICONS = { Compass, PenLine, Search, MessageCircle, Mail, Target };

export const ServiceIcon = ({ name, className = "h-5 w-5" }) => {
  const Icon = ICONS[name] || Compass;
  return <Icon className={className} />;
};
